import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location);
}

const router = new VueRouter({
  scrollBehavior: () => ({
    y: 0
  }),
  routes: [
    {
      path: '/',
      redirect: "/index",
      meta: {
        index: 0
      }
    },
    {
      path: '/index',
      name: 'index',
      component: () => import('@/pages/index.vue'),
      meta: {
        index: 0,
        title: 'about us'
      }
    },
    {
      path: '/team',
      name: 'team',
      component: () => import('@/pages/team.vue'),
      meta: {
        index: 1,
        title: 'our team'
      }
    },
    {
      path: '/strategy',
      name: 'strategy',
      component: () => import('@/pages/strategy.vue'),
      meta: {
        index: 2,
        title: 'our strategy'
      }
    },
    {
      path: '/contact',
      name: 'contact',
      component: () => import('@/pages/contact.vue'),
      meta: {
        index: 3,
        title: 'contact us'
      }
    }
  ]
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js